import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadershipMember } from '../leaderboard-home';

@Component({
  selector: 'app-leaderboard-organisation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './leaderboard-organisation.html',
  styleUrl: './leaderboard-organisation.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeaderboardOrganisation {
  @Input({ required: true }) leadershipMembers: LeadershipMember[] = [];
  @Input({ required: true }) organisationPagination: {
    hasNext?: boolean;
    isLoading?: boolean;
  } = {};
  @Input({ required: true }) showLoadMore = false;
  @Output() loadMore = new EventEmitter<void>();

  emitLoadMore(): void {
    this.loadMore.emit();
  }

  featuredSubtitle(member: LeadershipMember): string {
    const n = member.members ?? 0;
    return n === 1 ? '1 Member' : `${n} Members`;
  }

  rowSubtitle(member: LeadershipMember): string {
    return this.featuredSubtitle(member);
  }
}
